module.exports = __webpack_public_path__ + "img/4.049852c6.jpg";